import { queryParams, UrlParams, UrlParamTypes } from '@dxp-module/common'

const collectedFilters = () => {
  const token = queryParams.getParam(UrlParamTypes.TOKEN, window.location)
  const hideFaModule = queryParams.getParam(
    UrlParamTypes.HIDE_FA_MODULE,
    window.location
  )
  const dxpPreview = queryParams.getParam(
    UrlParamTypes.DXP_PREVIEW,
    window.location
  )

  const filters: UrlParams = {
    token: token || '',
    hideFaModule: hideFaModule || '',
    dxpPreview: dxpPreview || '',
  }

  return { filters }
}

export default collectedFilters
